import { __decorate } from "tslib";
import { Getter } from 'vuex-class';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import moment from 'moment';
let InboxManagerMixin = class InboxManagerMixin extends Vue {
    constructor() {
        super(...arguments);
        this.shouldScrollToBottom = true;
        this.pageRecipientImage = null;
        this.defaultPhoto = require('@/assets/images/cg_logo.png');
    }
    onRecipientChange() {
        this.displayRecipientPhoto();
    }
    displayRecipientPhoto() {
        if (this.selectedRecipient?.photo?.blob) {
            const { originalUrl } = this.selectedRecipient.photo.blob;
            this.pageRecipientImage = originalUrl;
            return;
        }
        this.pageRecipientImage = this.defaultPhoto;
    }
    formatTime(date) {
        return moment(date).format('MM/DD/YYYY, h:mm A');
    }
    getItemHeight() {
        return 80;
    }
    scrollToBottom() {
        if (!this.shouldScrollToBottom) {
            return;
        }
        this.$nextTick(() => {
            const container = this.$refs.messageContent;
            if (!container) {
                return;
            }
            container.scrollTop = container.scrollHeight;
        });
    }
};
__decorate([
    Getter('selectedRecipient')
], InboxManagerMixin.prototype, "selectedRecipient", void 0);
__decorate([
    Watch('selectedRecipient')
], InboxManagerMixin.prototype, "onRecipientChange", null);
InboxManagerMixin = __decorate([
    Component
], InboxManagerMixin);
export default InboxManagerMixin;
